import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/AuthShell";

export default function Login() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/api/auth/login", { email, password });
      setUser(data.user);
      toast.success(`Welcome back, ${data.user.name}.`);
      nav("/play");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell
      title="Return to the realm"
      subtitle="Your adventurer awaits."
      footer={
        <>
          New to Territoria?{" "}
          <Link to="/register" className="text-amber-500 hover:text-amber-400 underline" data-testid="link-register">
            Forge a character
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4 font-body" data-testid="login-form">
        <label className="block">
          <span className="text-stone-400 text-sm mb-1 block">Email</span>
          <input
            type="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-stone-950 border border-stone-700 rounded px-3 py-2 focus:border-amber-600 outline-none"
            data-testid="login-email"
          />
        </label>
        <label className="block">
          <span className="text-stone-400 text-sm mb-1 block">Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-stone-950 border border-stone-700 rounded px-3 py-2 focus:border-amber-600 outline-none"
            data-testid="login-password"
          />
        </label>
        <div className="flex items-center justify-between text-sm">
          <Link to="/forgot-password" className="text-stone-400 hover:text-amber-500" data-testid="link-forgot">
            Lost your password?
          </Link>
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="btn-gold w-full py-2.5 disabled:opacity-60"
          data-testid="login-submit"
        >
          {submitting ? "Opening the gate…" : "Enter Territoria"}
        </button>
      </form>
    </AuthShell>
  );
}
